(ns ballot-scout-v2-frontend.disposition-manager.views
  (:require
   [ballot-scout-v2-frontend.components.breadcrumb-navigator :refer [navigator]]
   [ballot-scout-v2-frontend.components.field-matcher :as fm]
   [ballot-scout-v2-frontend.components.icon :refer [icon] :as icon]
   [ballot-scout-v2-frontend.components.link :refer [link]]
   [ballot-scout-v2-frontend.components.pagination :refer [pagination]]
   [ballot-scout-v2-frontend.components.tooltip :refer [tooltip]]
   [ballot-scout-v2-frontend.components.upload :refer [upload-file]]
   [ballot-scout-v2-frontend.disposition-manager.common :refer [default-search-state]]
   [ballot-scout-v2-frontend.disposition-manager.events :as e.disposition]
   [ballot-scout-v2-frontend.disposition-manager.subs :as s.disposition]
   [ballot-scout-v2-frontend.events :as events]
   [ballot-scout-v2-frontend.request-helpers :as request-helpers]
   [ballot-scout-v2-frontend.resources.subs :as s.resources]
   [ballot-scout-v2-frontend.subs :as subs]
   [ballot-scout-v2-frontend.util :as util :refer [remove-empty-values]]
   [ballot-scout-v2-frontend.views :as views]
   [clojure.string :as str]
   [re-frame.core :as rf]))

(defn disposition-title [dispo]
  (cond
    (= :disposition-phase/canceled (e.disposition/phase-mappings (:disposition/phase dispo)))
    "Disposition Canceled"
    (:disposition/completed-ts dispo)
    "Disposition Completed"
    (:disposition/started-ts dispo)
    "Disposition In Progress"
    :else
    "Disposition Pending"))

(defn download-link [url]
  [:a {:href url :download "export.csv" :target "_blank"}
   [:strong "Download"]])

(defn preview-counts
  [{:disposition/keys [pre-ballots-mailed pre-ballots-received pre-ballots-flagged pre-ballots-accepted
                       pre-email-notys pre-sms-notys]}]
  [:div {:class "counts"}
   [:div {:class "pt-3"} "Ballot Updates"
    [:table
     [:tr
      [:td "Mailed:"]
      [:td {:class "pl-2"} [:strong pre-ballots-mailed]]]
     [:tr
      [:td "Received:"]
      [:td {:class "pl-2"} [:strong pre-ballots-received]]]
     [:tr
      [:td "Flagged:"]
      [:td {:class "pl-2"} [:strong pre-ballots-flagged]]]
     [:tr
      [:td "Accepted:"]
      [:td {:class "pl-2"} [:strong pre-ballots-accepted]]]
     [:tr
      [:td [:strong "Total:"]]
      [:td {:class "pl-2"} [:strong (+ pre-ballots-mailed
                                       pre-ballots-received
                                       pre-ballots-flagged
                                       pre-ballots-accepted)]]]]]
   [:div {:class "pt-3"} "Notifications to be Sent"
    [:table
     [:tr
      [:td "Email:"]
      [:td {:class "pl-2"} [:strong pre-email-notys]]]
     [:tr
      [:td "SMS:"]
      [:td {:class "pl-2"} [:strong pre-sms-notys]]]
     [:tr
      [:td [:strong "Total:"]]
      [:td {:class "pl-2"} [:strong (+ pre-sms-notys pre-email-notys)]]]]]])

(defn completed-counts
  [{:disposition/keys [pre-ballots-mailed pre-ballots-received pre-ballots-flagged pre-ballots-accepted
                       ballots-mailed ballots-received ballots-flagged ballots-accepted
                       pre-email-notys pre-sms-notys
                       email-notys sms-notys]}]
  (let [ballot-count-info-text "This number may be different than the number shown in the preview because one or more ballots have been updated."
        noty-count-info-text "This number may be different than the number shown in preview because voters subscribed or unsubscribed from notifications"
        prediction-clause (fn [info-text]
                            [:td {:class "pl-2 has-text-grey-light"}
                             [tooltip [icon ::icon/circle-question] info-text]])]
    [:div {:class "counts"}
     [:div {:class "pt-3"} "Ballot Updates"
      [:table
       [:tr
        [:td "Mailed:"]
        [:td {:class "pl-2"} [:strong ballots-mailed]]
        (when (not= pre-ballots-mailed ballots-mailed)
          [prediction-clause ballot-count-info-text])]
       [:tr
        [:td "Received:"]
        [:td {:class "pl-2"} [:strong ballots-received]]
        (when (not= pre-ballots-received ballots-received)
          [prediction-clause ballot-count-info-text])]
       [:tr
        [:td "Flagged:"]
        [:td {:class "pl-2"} [:strong ballots-flagged]]
        (when (not= pre-ballots-flagged ballots-flagged)
          [prediction-clause ballot-count-info-text])]
       [:tr
        [:td "Accepted:"]
        [:td {:class "pl-2"} [:strong ballots-accepted]]
        (when (not= pre-ballots-accepted ballots-accepted)
          [prediction-clause ballot-count-info-text])]
       [:tr
        [:td [:strong "Total:"]]
        [:td {:class "pl-2"} [:strong (+ ballots-mailed
                                         ballots-received
                                         ballots-flagged
                                         ballots-accepted)]]]]]
     [:div {:class "pt-3"} "Notifications Sent"
      [:table
       [:tr
        [:td "Email:"]
        [:td {:class "pl-2"} [:strong email-notys]]
        (when (not= pre-email-notys email-notys)
          [prediction-clause noty-count-info-text])]
       [:tr
        [:td "SMS:"]
        [:td {:class "pl-2"} [:strong sms-notys]]
        (when (not= pre-sms-notys sms-notys)
          [prediction-clause noty-count-info-text])]
       [:tr
        [:td [:strong "Total:"]]
        [:td {:class "pl-2"} [:strong (+ sms-notys email-notys)]]]]]]))

(defn disposition-summary
  [{:disposition/keys [id
                       rows-count processed-rows-count
                       created-ts started-ts completed-ts
                       invalid-rows-count invalid-rows-file-url
                       original-file-url update-record-file-url
                       phase
                       uploaded-by started-by
                       jurisdiction-id]
    :as dispo}
   on-partner-admin-page?
   title?]
  (let [dispo-route
        (if on-partner-admin-page?
          :ballot-scout-v2-frontend.routes/partner-disposition-manager
          :ballot-scout-v2-frontend.routes/jurisdiction-disposition-manager)
        voter-search-route
        (if on-partner-admin-page?
          :ballot-scout-v2-frontend.routes/partner-voter-lookup
          :ballot-scout-v2-frontend.routes/jurisdiction-voter-lookup)
        hide-privileged-info (and (not on-partner-admin-page?) (nil? jurisdiction-id))]
    [:div
     (when title?
       [:div
        [:h4 {:class "heading-4 mb-0"}
         (disposition-title dispo)
         (when (not hide-privileged-info)
           [link {:route-name dispo-route
                  :params {:partner-slug @(rf/subscribe [::subs/current-partner-slug])
                           :jurisdiction-slug @(rf/subscribe [::subs/current-jurisdiction-slug])
                           :election-slug @(rf/subscribe [::subs/current-election-slug])
                           :disposition-id id}
                  :class "ml-4"}
            [:button {:class "button is-clickable is-small"}
             "View Disposition"]])]
        (when hide-privileged-info
          [:div {:class "is-italic has-text-grey"}
           "This disposition was started by an admin user: detailed info will be hidden."])])
     (cond
       started-ts
       [:div "Rows processed: " [:strong processed-rows-count " / " rows-count]]
       rows-count
       [:div "Rows to process: " [:strong rows-count]])

     (when (not title?)
       [:<>
        (cond
          (= :disposition-phase/preview (e.disposition/phase-mappings phase))
          [preview-counts dispo]

          (and (= :disposition-phase/final (e.disposition/phase-mappings phase))
               (some? completed-ts))
          [completed-counts dispo])

        [:div {:class "pt-3"}
         [:div "Total rows in original file: "
          [:strong rows-count]]
         (when invalid-rows-count
           [:div "Total invalid rows: "
            [:strong invalid-rows-count]])
         (when (and original-file-url (not hide-privileged-info))
           [:div "Original file: " [download-link original-file-url]])
         (when (and invalid-rows-file-url (not hide-privileged-info))
           [:div "Invalid rows file: " [download-link invalid-rows-file-url]])
         (when (and update-record-file-url (not hide-privileged-info))
           [:div "Update summary file: " [download-link update-record-file-url]])]])

     (cond
       completed-ts
       [:div {:class "pt-3"}
        "Completed at: "
        [:strong (util/render-datetime completed-ts)]
        (when started-by
          [:span " by " [:strong started-by]])]
       started-ts
       [:div {:class "pt-3"}
        "Started at: "
        [:strong (util/render-datetime started-ts)]
        (when started-by
          [:span " by " [:strong started-by]])]
       created-ts
       [:div {:class "pt-3"}
        "Created at: "
        [:strong (util/render-datetime created-ts)]
        (when uploaded-by
          [:span " by " [:strong uploaded-by]])])

     (when completed-ts
       [:div {:class "pt-3"}
        [link {:route-name voter-search-route
               :params {:partner-slug @(rf/subscribe [::subs/current-partner-slug])
                        :jurisdiction-slug @(rf/subscribe [::subs/current-jurisdiction-slug])
                        :election-slug @(rf/subscribe [::subs/current-election-slug])}
               :query {:disposition-id id}}
         [:span {:class "has-text-weight-bold"}
          "View the Updated Ballots"]]])]))

(defn- disposition-uploader [upload-stage-component]
  (let [disposition-guide (:disposition-guide @(rf/subscribe [::s.resources/resource-urls]))]
    [:div {:class (str "disposition-uploader")}
     [:div {:class "level"}
      [:div {:class "level-left"}
       [:h1 {:class "heading-1"} "New Disposition Import"]]
      [:div {:class "level-right"}
       [navigator
        @(rf/subscribe [::s.disposition/current-disposition-phases])
        :disposition-phase/upload-file]]]
     [:div {:class "columns pb-6"}
      [:div {:class "column"}
       [:span {:class "has-text-weight-bold"}
        "Locate your disposition file and upload it to Ballot Scout"]
       (when disposition-guide
         [:div {:class "pt-4"}
          "To review the disposition import user guide, please "
          [:a {:href disposition-guide :target "_blank"} "click here"]])]]
     [:div {:class "columns"}
      [:div {:class "column"}
       upload-stage-component]]]))

(defn jurisdiction-create-page []
  (let [current-jurisdiction-slug @(rf/subscribe [::subs/current-jurisdiction-slug])
        current-jurisdiction @(rf/subscribe [::subs/current-jurisdiction])
        current-election @(rf/subscribe [::subs/current-election])
        upload-file-fn #(rf/dispatch [::e.disposition/upload-for-jurisdiction
                                      (:jurisdiction/id @(rf/subscribe [::subs/current-jurisdiction]))
                                      @(rf/subscribe [::subs/current-election-slug])
                                      %])]
    (if (and current-jurisdiction current-election)
      [:div.disposition-manager
       [disposition-uploader [upload-file
                              (rf/subscribe [::s.disposition/upload])
                              upload-file-fn
                              [:ul
                               [:li "The file must be formatted as .csv or .txt"]
                               [:li "The file must contain a header row of field names"]]]]]
      (if-let [fetch-error (or @(rf/subscribe [::request-helpers/failed-request
                                               [::events/fetch-jurisdiction current-jurisdiction-slug]])
                               @(rf/subscribe [::request-helpers/failed-request
                                               [::events/fetch-elections-for-jurisdiction current-jurisdiction-slug]]))]
        (:status-text fetch-error)
        [:div.loading
         [:img.centered-img {:src "/images/compass-100x100.png"}]]))))

(defn partner-create-page []
  (let [current-partner-slug @(rf/subscribe [::subs/current-partner-slug])
        current-partner @(rf/subscribe [::subs/current-partner])
        current-election @(rf/subscribe [::subs/current-election])
        upload-file-fn #(rf/dispatch [::e.disposition/upload-for-partner
                                      (:partner/id @(rf/subscribe [::subs/current-partner]))
                                      @(rf/subscribe [::subs/current-election-slug])
                                      %])]
    (if (and current-partner current-election)
      [:div.disposition-manager
       [disposition-uploader [upload-file
                              (rf/subscribe [::s.disposition/upload])
                              upload-file-fn
                              [:ul
                               [:li "The file must be formatted as .csv or .txt"]
                               [:li "The file must contain a header row of field names"]]]]]
      (if-let [fetch-error (or @(rf/subscribe [::request-helpers/failed-request
                                               [::events/fetch-partner current-partner-slug]])
                               @(rf/subscribe [::request-helpers/failed-request
                                               [::events/fetch-elections-for-partner current-partner-slug]]))]
        (:status-text fetch-error)
        [:div.loading
         [:img.centered-img {:src "/images/compass-100x100.png"}]]))))

(def standard-fields [{:text "Voter ID"       :name :column-voter-id      :required (constantly true)}
                      {:text "Received Date"  :name :column-receive-date  :required (constantly false)}
                      {:text "Sent Date"      :name :column-sent-date     :required (constantly false)}
                      {:text "Processed Date" :name :column-process-date  :required (constantly false)}
                      {:text "Ballot Status"  :name :column-ballot-status :required (constantly true)}
                      {:text "Election Date"  :name :column-election-date :required (constantly false)}])

(defn field-matcher [headers]
  (let [setting-column-mapping?
        (= :setting-column-mapping (get-in @(rf/subscribe [::s.disposition/disposition-data]) [:header-state :status]))
        submit-mapping-fn
        (fn [header-mapping]
          (rf/dispatch [::e.disposition/post-column-mapping
                        @(rf/subscribe [::subs/current-disposition])
                        header-mapping]))]
    [:div
     [:div {:class "has-text-weight-bold"}
      "Please map the columns in your file to Ballot Scout's fields"]
     [:div {:class "content"}
      [:ul
       [:li "If there is a field you will not be processing or that is not an existing Ballot Scout field, please map it to \"do not import\""]
       [:li "Once you have mapped all of your fields, please click \"Confirm Headers\""]]]
     [fm/field-matcher standard-fields headers setting-column-mapping? submit-mapping-fn]
     [disposition-summary @(rf/subscribe [::subs/current-disposition]) @(rf/subscribe [::subs/on-partner-admin-page?])]]))

(defn field-matcher-section []
  (when-let [headers (not-empty @(rf/subscribe [::s.disposition/headers]))]
    [field-matcher headers]))

(defn restart-button [style-class]
  (let [on-partner-admin-page? @(rf/subscribe [::subs/on-partner-admin-page?])
        route (if on-partner-admin-page?
                :ballot-scout-v2-frontend.routes/create-disposition-for-partner
                :ballot-scout-v2-frontend.routes/create-disposition-for-jurisdiction)
        params (if on-partner-admin-page?
                 {:partner-slug @(rf/subscribe [::subs/current-partner-slug])
                  :election-slug @(rf/subscribe [::subs/current-election-slug])}
                 {:partner-slug @(rf/subscribe [::subs/current-partner-slug])
                  :jurisdiction-slug @(rf/subscribe [::subs/current-jurisdiction-slug])
                  :election-slug @(rf/subscribe [::subs/current-election-slug])})
        {:disposition/keys [id]} @(rf/subscribe [::subs/current-disposition])]
    [:button {:class (str/join " " ["button" style-class])
              :on-click #(do
                           (rf/dispatch [::e.disposition/cancel-disposition id])
                           (rf/dispatch [:ballot-scout-v2-frontend.routes/navigate route params]))}
     [:span "Restart with New File"]]))

(defn preview-section []
  (let [{:disposition/keys [invalid-rows-file-url pre-rows-skipped rows-count]
         :as current-dispo}
        @(rf/subscribe [::subs/current-disposition])
        start-disposition-fn #(rf/dispatch [::e.disposition/start-disposition current-dispo])
        to-update-count (- rows-count pre-rows-skipped)
        invalid-file-download-component
        [:div "Click "
         [:a {:href invalid-rows-file-url
              :download "export.csv"
              :target "_blank"}
          [:strong "here"]]
         " to download a file with your file's errors."]]
    (cond
      (= 0 to-update-count)
      [:div
       [:div
        [:span {:class "has-text-danger pr-2"}
         [icon ::icon/xmark]]
        "No rows could be processed."]
       invalid-file-download-component
       [:div {:class "mt-4"}
        [restart-button "is-primary"]]]

      (pos? pre-rows-skipped)
      [:div
       [:div {:class "is-flex is-align-items-center"}
        [:img {:class "image alert-color mr-2" :src "/images/alert_color.png"}]
        pre-rows-skipped " out of " rows-count " rows could not be processed."]
       invalid-file-download-component
       [disposition-summary current-dispo @(rf/subscribe [::subs/on-partner-admin-page?])]
       [:div {:class "mt-4"}
        [restart-button "is-light"]
        [:button {:class "button is-primary ml-3" :on-click start-disposition-fn}
         [:span (str "Update " to-update-count " Ballot" (when (not= 1 to-update-count) "s"))]]]]

      :else
      [:div
       [:div
        [:span {:class "has-text-success pr-2"}
         [icon ::icon/check-circle]]
        "Your disposition file is ready to be processed!"]
       [disposition-summary current-dispo @(rf/subscribe [::subs/on-partner-admin-page?])]
       [:div {:class "mt-4"}
        [restart-button "is-light"]
        [:button {:class "button is-primary ml-3" :on-click start-disposition-fn}
         [:span (str "Update " to-update-count " Ballot" (when (not= 1 to-update-count) "s"))]]]])))

(defn final-section []
  (let [current-dispo @(rf/subscribe [::subs/current-disposition])]
    [:<>
     [disposition-summary current-dispo @(rf/subscribe [::subs/on-partner-admin-page?])]
     (when (nil? (:disposition/completed-ts current-dispo))
       [:div.loading
        [:img.centered-img {:class "p-6" :src "/images/compass-100x100.png"}]])]))

(defn manager []
  (let [fetch-status @(rf/subscribe [::s.disposition/fetch-disposition-status])
        dispo @(rf/subscribe [::subs/current-disposition])
        phase (e.disposition/phase-mappings (:disposition/phase dispo))]
    (case fetch-status
      :errored [:h1 {:class "heading-1"} "Could not load disposition."]
      :fetching [:div
                 [:div
                  [:h1 {:class "heading-1"} "Disposition Details"]]
                 [:div.loading
                  [:img {:class "p-2 centered-img" :src "/images/compass-100x100.png"}]]]
      [:div
       [:div {:class "level"}
        [:div {:class "level-left"}
         [:h1 {:class "heading-1"}
          (disposition-title dispo)]]
        [:div {:class "level-right"}
         [navigator
          @(rf/subscribe [::s.disposition/current-disposition-phases])
          phase]]]
       (case phase
         :disposition-phase/match-fields [field-matcher-section]
         :disposition-phase/preview      [preview-section]
         :disposition-phase/canceled     [disposition-summary dispo @(rf/subscribe [::subs/on-partner-admin-page?])]
         :disposition-phase/processing   [final-section]
         :disposition-phase/final        [final-section]
         [:div.loading
          [:img.centered-img {:style {:padding "2em"} :src "/images/compass-100x100.png"}]])])))

(defn manager-page []
  (let [{:disposition/keys [jurisdiction-id] :as current-disposition}
        @(rf/subscribe [::subs/current-disposition])
        fetch-error @(rf/subscribe [::request-helpers/failed-request
                                    ::e.disposition/fetch-disposition
                                    @(rf/subscribe [::subs/current-disposition-id])])]
    (cond
      (and (some? current-disposition)
           (nil? jurisdiction-id)
           (not @(rf/subscribe [::subs/on-partner-admin-page?])))
      [views/page-404]

      (some? current-disposition)
      [:div {:class "disposition-manager"}
       [manager]]

      (some? fetch-error)
      (:status-text fetch-error)

      (= :fetching  @(rf/subscribe [::s.disposition/fetch-disposition-status]))
      [:div.loading
       [:img.centered-img {:style {:padding "2em"} :src "/images/compass-100x100.png"}]]

      :else
      [views/page-404])))

(defn- change-jurisdiction-dispositions-list-page!
  [new-pagination-state]
  (let [new-state (remove-empty-values new-pagination-state)]
    (rf/dispatch [:ballot-scout-v2-frontend.routes/navigate
                  :ballot-scout-v2-frontend.routes/disposition-list-for-jurisdiction
                  {:partner-slug @(rf/subscribe [::subs/current-partner-slug])
                   :jurisdiction-slug @(rf/subscribe [::subs/current-jurisdiction-slug])
                   :election-slug @(rf/subscribe [::subs/current-election-slug])}
                  new-state])))

(defn- change-partner-dispositions-list-page!
  [new-pagination-state]
  (let [new-state (remove-empty-values new-pagination-state)]
    (rf/dispatch [:ballot-scout-v2-frontend.routes/navigate
                  :ballot-scout-v2-frontend.routes/disposition-list-for-partner
                  {:partner-slug @(rf/subscribe [::subs/current-partner-slug])
                   :election-slug @(rf/subscribe [::subs/current-election-slug])}
                  new-state])))

(defn- list-view [{:keys [results total-pages] :or {results [] total-pages 0}} page-change-fn]
  (let [dispos (filter #(e.disposition/phase-mappings (:disposition/phase %)) results)
        url-state (rf/subscribe [::subs/query-params])]
    (if (empty? dispos)
      "No dispositions have been created yet."
      [:div
       [:div {:class "mb-6"}
        (for [dispo dispos]
          [:div {:class "columns"}
           [:div {:class "column is-12"}
            [disposition-summary dispo @(rf/subscribe [::subs/on-partner-admin-page?]) true]
            [:hr]]])]
       [pagination {:curr-page (:page (merge default-search-state @url-state))
                    :total-pages total-pages
                    :on-page #(page-change-fn (assoc @url-state :page %))}]])))

(defn- list-page [create-dispo-route page-change-fn]
  [:div {:class "disposition-list"}
   [:div {:class "level"}
    [:div {:class "level-left"}
     [:h1 {:class "heading-1"} "Past Disposition Imports"]]
    [:div {:class "level-right"}
     [link create-dispo-route
      [:button {:class "button"} "New Disposition Import"]]]]
   (let [{:keys [status data error-response]} @(rf/subscribe [::s.disposition/list-state])]
     (case status
       :success [list-view data page-change-fn]
       :errored [:div error-response]
       ;default - fetching
       [:div.loading
        [:img.centered-img {:src "/images/compass-100x100.png"}]]))])

(defn jurisdiction-list-page []
  [list-page
   {:route-name :ballot-scout-v2-frontend.routes/create-disposition-for-jurisdiction
    :params {:partner-slug @(rf/subscribe [::subs/current-partner-slug])
             :jurisdiction-slug @(rf/subscribe [::subs/current-jurisdiction-slug])
             :election-slug @(rf/subscribe [::subs/current-election-slug])}}
   change-jurisdiction-dispositions-list-page!])

(defn partner-list-page []
  [list-page
   {:route-name :ballot-scout-v2-frontend.routes/create-disposition-for-partner
    :params {:partner-slug @(rf/subscribe [::subs/current-partner-slug])
             :election-slug @(rf/subscribe [::subs/current-election-slug])}}
   change-partner-dispositions-list-page!])
